var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('BaseHero',{attrs:{"title":'Pomoc i kontakt'}}),_c('HelpContact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }